<template>
  <div class="container">
    <p class="message">
      {{ $t('disabledModeScreen.message') }}
    </p>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'

export default {
  mounted() {
    this.setHideAppUI(true)
  },
  beforeDestroy() {
    this.setHideAppUI(false)
  },
  methods: {
    ...mapMutations(['setHideAppUI']),
  },
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.message {
  text-align: center;
  max-width: 320px;
}
</style>
